import React, { useEffect, useId, useRef, useState } from 'react';
import { Lead, CrmUser } from '../../../../types';
import { WinDealModal } from '../../../../features/kanban/components/modals/WinDealModal';
import { LossReasonModal } from '../../../../features/kanban/components/modals/LossReasonModal';
import { EditableField } from '../../../../components/shared/InlineEditable';

interface DealCardFooterProps {
    lead: Lead;
    crmUsers: CrmUser[];
    onValueSave: (value: string | number) => void;
    onAgentChange: (agentId: string) => void;
    winDealModal: { isOpen: boolean; leadName: string; currentValue: number };
    lossReasonModal: { isOpen: boolean; leadName: string };
    closeWinModal: () => void;
    closeLossModal: () => void;
    handleConfirmWin: (v: number) => Promise<void>;
    handleConfirmLoss: (reasonId: string, comments?: string) => Promise<void>;
}

export const DealCardFooter: React.FC<DealCardFooterProps> = ({
    lead,
    crmUsers,
    onValueSave,
    onAgentChange,
    winDealModal,
    lossReasonModal,
    closeWinModal,
    closeLossModal,
    handleConfirmWin,
    handleConfirmLoss
}) => {
    const agentSelectId = useId();
    const [saved, setSaved] = useState(false);
    const savedTimer = useRef<ReturnType<typeof setTimeout> | null>(null);

    useEffect(() => () => {
        if (savedTimer.current) clearTimeout(savedTimer.current);
    }, []);

    const flashSaved = () => {
        setSaved(true);
        if (savedTimer.current) clearTimeout(savedTimer.current);
        savedTimer.current = setTimeout(() => setSaved(false), 1400);
    };

    const handleAgentChange = (agentId: string) => {
        onAgentChange(agentId);
        flashSaved();
    };

    return (
    <>
        <EditableField
            label="Valor"
            value={lead.value}
            type="currency"
            onSave={onValueSave}
        />
        <div>
            <div className="mb-1 flex items-center justify-between gap-2">
                <label htmlFor={agentSelectId} className="text-body-sm text-muted">Responsável</label>
                {saved && <span className="chat-saved-flash" role="status">✓ Salvo</span>}
            </div>
            <select
                id={agentSelectId}
                name="dealAgent"
                value={lead.agent || ''}
                onChange={(e) => handleAgentChange(e.target.value)}
                className="input input--chat-window min-h-11 w-full"
            >
                <option value="">Não atribuído</option>
                {crmUsers.map(user => (
                    <option key={user.id} value={user.id}>{user.name}</option>
                ))}
            </select>
        </div>
        <WinDealModal
            isOpen={winDealModal.isOpen}
            leadName={winDealModal.leadName}
            currentValue={winDealModal.currentValue}
            onClose={closeWinModal}
            onConfirm={handleConfirmWin}
        />
        <LossReasonModal
            isOpen={lossReasonModal.isOpen}
            leadName={lossReasonModal.leadName}
            onClose={closeLossModal}
            onConfirm={handleConfirmLoss}
        />
    </>
    );
};
